module.exports = __webpack_public_path__ + "img/ep.cdfa896f.png";